import { useEffect } from 'react';
import { navigateExternalNoReferrer } from '../utils/navigate-no-referer';

export function useBackRedirect(
  redirectUrl?: string,
  opts?: { newTab?: boolean, extraParams?: URLSearchParams | string },
) {
  useEffect(() => {
    if (!redirectUrl) return;

    window.history.pushState(null, '', window.location.href);

    let triggered = false;
    const handlePopState = () => {
      if (triggered) return;
      triggered = true;
      navigateExternalNoReferrer(redirectUrl, {
        newTab: !!opts?.newTab,
        extraParams: opts?.extraParams,
      });
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [redirectUrl, opts?.newTab]);
}
